import { useEffect, useState } from 'react';
import { getApi } from '../../../../api/call.api';
import { urlApi } from '../../../../api/url.api';

const ChatFeedbackReport = () => {

    const [data, setData] = useState([]);

    const getData = async () => {
        let resp = await getApi(urlApi.chatFeedbackAnalysis);
        if (resp.responseCode === 200) {
            setData(resp?.data);
        } else {
            setData([]);
        }
    }

    useEffect(() => {
        getData();
    }, []);

    return (
        <div className='!mb-4 bg-white p-2 rounded-lg'>
            <div className="flex items-center gap-2 flex-wrap mb-4">
                <p className='mb-0 text-xs font-bold text-[var(--grey)]'>Feedbacks</p>
            </div>
            <div className="flex justify-around">
                {
                    data?.length ?
                        data?.map((item, index) => {
                            return (
                                <div key={index}><FeedbackBar item={item} /></div>
                            )
                        }) : <p>No Data Available</p>
                }
            </div>
        </div>
    )
}

export default ChatFeedbackReport

const FeedbackBar = ({ item }) => {
    return (
        <div className='flex items-center flex-col !gap-2'>
            <p className='text-xs'>{Math.floor(item?.percentage) || 0}%</p>
            <div className='h-52 w-12 bg-gray-200 rounded-md overflow-hidden relative'>
                <div className='w-full bg-[var(--secondary)] absolute bottom-0' style={{ height: Math.min(item?.percentage, 100) + "%" }}></div>
            </div>
            <p className='text-xs mb-1'>{item?.feedback == 1 ? 'Bad Rating' : item?.feedback == 2 ? 'Ok Rating' : item?.feedback == 3 ? 'Good Rating' : item?.feedback == 4 ? 'No Rating' : null}</p>
        </div>

    )
}